<style scoped>
    .ant-table,
    .ant-table thead > tr > th,
    .ant-table tbody > tr > td {
    border: 1px solid #e8e8e8;
    border-collapse: collapse;
    }

</style>
<template>
    <div style="min-height:85vh">
        <a-form style="display:flex;width:100%;" :form="dashboardCountriesForm">
            <div>
                <table class="ant-table" style="width: 100%; border: 1px solid #f0f0f0;">
                    <thead class="ant-table-thead">
                        <tr>
                        <th style="width: 400px;">Country</th>
                        <th style="width: 200px;">Operation</th>
                        </tr>
                    </thead>
                    <draggable
                        v-model="selectedCountryList"
                        tag="tbody"
                        :move="onMove"
                        @end="onDragEnd"
                    >
                        <tr
                        v-for="(record, index) in selectedCountryList"
                        :key="index"
                        style="cursor: move;"
                        >
                        <td>
                            <a-form-item style="margin-bottom: 0px;">
                            <a-input
                                v-decorator="[
                                `${TABLECOUNTRYSTYLE}[${index}].country`,
                                {
                                    initialValue: record.country || '',
                                    rules: [{ required: true, message: 'Input Country!' }]
                                }
                                ]"
                            />
                            </a-form-item>
                            <a-form-item style="display: none;">
                                <a-input
                                    v-decorator="[
                                    `${TABLECOUNTRYSTYLE}[${index}]._id`,
                                    { initialValue: record._id }
                                    ]"
                                />
                            </a-form-item>
                        </td>
                        <td>
                            <a @click="DeleteOneCountry(record.key)">Delete</a>
                        </td>
                        </tr>
                    </draggable>
                </table>

                <div style="display:flex;margin-top:10px">
                    <a-button class="editable-add-btn" @click="addCountryData">
                        Add Country
                    </a-button>
                    <a-button class="editable-add-btn" style="margin-left:10px" @click="saveCountryData"
                        type="primary">
                        Save Countries
                    </a-button>
                </div>
            </div>
        </a-form>
    </div>
</template>

<script>
import { api } from '../helpers/Helpers';
import draggable from 'vuedraggable';

const selectedCountryList = [];
var moment = require('moment-timezone');
const TABLECOUNTRYSTYLE = 'tableCountryStyle';

const columnsCountryStyle = [
    {
        title: 'country',
        dataIndex: 'country',
        key: 'country',
        width: 400,
        scopedSlots: { customRender: 'country' },
    },
    {
        title: 'operation',
        dataIndex: 'operation',
        key: 'operation',
        width: 200,
        scopedSlots: { customRender: 'operation' },
    },
];

export default {
    data() {
        return {
            dashboardCountriesForm: this.$form.createForm(this),
            columnsCountryStyle,
            TABLECOUNTRYSTYLE,
            selectedCountryList
        }
    },
    created() {
        this.getCountryList();
    },
    components: {
        draggable
    },
    methods: {
        moment,
        onDragEnd() {
            // Reassign keys based on new order
            this.selectedCountryList = this.selectedCountryList.map((item, index) => {
            return { ...item, key: index + 1 };
            });
        },
        onMove(e) {
            // Optional: control move behavior
            return true;
        },
        DeleteOneCountry(key) {
            this.selectedCountryList = this.selectedCountryList.filter(
            item => item.key !== key
            );
        },
        addCountryData() {
            const newData = {
                key: this.selectedCountryList.length,
                name: '',
            };
            this.selectedCountryList.push(newData);
        },
        DeleteOneCountry(_key) {
            let objIndex = this.selectedCountryList.findIndex((obj => obj.key == _key));
            this.selectedCountryList.splice(objIndex, 1);
            this.updateCountryList();
        },
        updateCountryList() {
            for (let i = 0; i < this.selectedCountryList.length; i++) {
                this.selectedCountryList[i].key = i;
            }
        },
        getCountryList: async function () {
            const res = await api.getCountryInfo();
            // console.log(res);
            if (res.length > 0) {
                this.selectedCountryList = res;
                console.log("selectedCountryList--->", res);
            }
        },
        saveCountryData() {
            const { dashboardCountriesForm: { validateFields } } = this
            validateFields((errors, values) => {
                if (!errors) {
                    let partOneArr = [];
                    const dataList = values[TABLECOUNTRYSTYLE]; // this is now an array of objects
                    if (Array.isArray(dataList)) {
                    console.log("dataList-->", dataList);
                    dataList.forEach((item, index) => {
                        const obj = {
                        country: item.country,
                        slug: item.country.toLowerCase().replace(/\s/g, '-'),
                        key: index,
                        };
                        if (item._id) {
                        obj._id = item._id; // assign _id only if it exists
                        }
                        partOneArr.push(obj);
                    });
                    }

                    const lastInfo = {
                    datalist: partOneArr
                    };
                    console.log("partOneArr--->", partOneArr);
                    this.sendSelectedCountryData(lastInfo);
                }
            });
        },
        sendSelectedCountryData: async function (_array) {

            const res = await api.setSelectedCountryInfo(_array);
            // console.log(res);
            if (res != undefined)
                this.$message.success('Saving Success!');
        },
    }
}
</script>